export const useStyles = () => {
    return {
        number: ({ percentageExisted }: { percentageExisted: boolean }) => ({
            fontSize: percentageExisted ? '32px' : '45px',
            color: 'c_grey.main'
        }),
        text: ({ percentageExisted }: { percentageExisted: boolean }) => ({
            fontSize: '13px',
            fontWeight: '700'
        }),
        percentage: {
            fontSize: '22px',
            color: 'c_grey.100',
            marginTop: -1.5
        },
        display: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        container: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'start'
        }
    }
}